import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const useIsomorphicLayoutEffect =
  typeof window !== "undefined" ? useLayoutEffect : useEffect;

/**
 * Resets scroll to the top on every navigation so the next screen is not
 * offset by the previous page’s scroll position.
 */
export function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useIsomorphicLayoutEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname, search, hash]);

  return null;
}

export default ScrollToTop;
